import React from 'react'
import Stats from '../components/Stats'
import Testimonials from '../components/Testimonials';
import Scroll from '../components/Scroll';

const Home = () => {
  return (
    <div className=''>
    <Stats />
    <Testimonials />

    <Scroll/>
    </div>
  )
}

export default Home;